import React, { useState, useEffect, useCallback } from 'react';
import { useUser } from '../UserContext';
import { Link, useNavigate } from 'react-router-dom'; 
import './index.css'; // Arquivo para estilização
import Select from 'react-select';

const Desenvolvimento = () => {
  const { userInfo } = useUser(); // Informações do usuário
  const navigate = useNavigate(); // Hook para navegação
  const [desenvolvimentos, setDesenvolvimentos] = useState([]); // Lista de desenvolvimentos
  const [clientes, setClientes] = useState([]); // Lista de clientes para filtro
  const [filtros, setFiltros] = useState({ cliente: '', status: '' }); // Filtros com valores iniciais
  const [selectedDesenvolvimento, setSelectedDesenvolvimento] = useState(null); // Item selecionado para o modal
  const [statusAtualizado, setStatusAtualizado] = useState(''); // Atualização de status
  const [showLaunchModal, setShowLaunchModal] = useState(false); // Modal de lançamento
  const [showEditModal, setShowEditModal] = useState(false); // Modal de edição
  const [formData, setFormData] = useState({
    cliente: '',
    prioridade: '',
    descricao: ''
  }); // Estado para os dados do formulário
  
  useEffect(() => {
    // Verifica se userInfo.id está definido; caso contrário, redireciona para a tela de login
    if (!userInfo?.id) {
      navigate('/'); // Redireciona para a página inicial (home)
    }
  }, [userInfo, navigate]);

  useEffect(() => {
    // Adiciona um listener para capturar o clique no F5
    const handleBeforeUnload = (event) => {
      // Mensagem de confirmação ao pressionar F5
      const confirmationMessage = "Tem certeza de que deseja sair desta tela?";
      event.preventDefault();
      event.returnValue = confirmationMessage; // Mensagem de confirmação
      return confirmationMessage;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    // Remove o listener ao desmontar o componente
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    // Fetch para obter lista de clientes
    fetch(userInfo.url + '/listaCliente')
      .then(response => response.json())
      .then(data => setClientes(data))
      .catch(error => console.error('Erro ao buscar clientes:', error));
  },[userInfo]);
  
  useEffect(() => {
    // Carregar desenvolvimentos pendentes por padrão ao abrir a tela
    fetch(userInfo.url + '/listaDevs') // Filtra status "Pendente" na requisição
      .then(response => response.json())
      .then(data => setDesenvolvimentos(data)) // Salva no estado
      .catch(error => console.error('Erro ao buscar desenvolvimentos:', error));
  },[userInfo]);

// Atualização da função de busca de desenvolvimentos para aceitar filtros
const buscarDesenvolvimentos = useCallback((appliedFiltros = { cliente: '', status: '' }) => {
  const { cliente, status } = appliedFiltros; // Agora se appliedFiltros for undefined, ele terá os valores padrão
  const query = [];
  if (cliente) query.push(`cliente=${cliente}`);
  if (status) query.push(`status=${status}`);
  
  fetch(userInfo.url + `/listaDevs`)
    .then((response) => response.json())
    .then((data) => setDesenvolvimentos(data))
    .catch((error) => console.error('Erro ao buscar desenvolvimentos:', error));
}, [userInfo.url]); // Dependência da URL do userInfo
   
  useEffect(() => {
    if (userInfo?.id) {
      buscarDesenvolvimentos();
    }
  }, [userInfo?.id, buscarDesenvolvimentos]); // ✅ Correto agora  

  const handleSubmit = (e) => {
    e.preventDefault();
    // Fazendo POST com os dados do formulário
    fetch(userInfo.url + '/insDev'/*'https://n8n.wensystem.com.br/webhook-test/5ce422d6-882e-4954-a164-9d9a1506b313'*/, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    })
      .then(response => {
        if (!response.ok) throw new Error('Erro ao enviar desenvolvimento.');
        return response.json();
      })
      .then(data => {
        alert('Desenvolvimento lançado com sucesso!');
        setShowLaunchModal(false);
        setFormData({ cliente: '', prioridade: '', descricao: '' });
        buscarDesenvolvimentos(); // <<--- Aqui você atualiza a lista!
      })      
      .catch(error => {
        console.error('Erro:', error);
        alert('Houve um erro ao lançar o desenvolvimento.');
      });
  };

  useEffect(() => {
    if (userInfo?.id) {
      buscarDesenvolvimentos(filtros); // Atualiza a lista de desenvolvimentos com os filtros aplicados
    }
  }, [filtros, userInfo?.id, buscarDesenvolvimentos]); // Inclua userInfo?.id como dependência  

  const hoje = new Date();
  const dataSemHora = `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}-${String(hoje.getDate()).padStart(2, '0')}`;
  console.log(dataSemHora); // Exibe a data no formato AAAA-MM-DD

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData,
                    [name]: value,
                    ALT_DTA_REGISTRO: hoje,
                    ALT_STATUS: 'Pendente',
                    FUN_ID: userInfo.id });
  };
  
 // Atualização da função de alteração do filtro
 const handleFilterChange = (e) => {
  const { name, value } = e.target;
  setFiltros((prevFiltros) => {
    const newFiltros = { ...prevFiltros, [name]: value };
    return newFiltros;
  });
};

  const handleDesenvolvimentoClick = (desenvolvimento) => {
    setSelectedDesenvolvimento(desenvolvimento);
    setStatusAtualizado(desenvolvimento.status); // Carrega o status atual
    setShowEditModal(true); // Exibe o modal de edição
  };

  const handleStatusUpdate = (e) => {
    e.preventDefault();
    
    const payload = {
      executar: selectedDesenvolvimento.ALT_EXECUTAR, // O que executar
      status: statusAtualizado, // Status atualizado
      versao: selectedDesenvolvimento.ALT_VERSAO, // Versão
      id: selectedDesenvolvimento.ALT_ID, // ID do desenvolvimento
    };
  
    console.log('Payload enviado:', payload); // Verifica os dados enviados
  
    fetch(userInfo.url + '/attDev'/*'https://n8n.wensystem.com.br/webhook-test/5ce422d6-882e-4954-a164-9d9a1506b313'*/, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(response => {
        if (!response.ok) throw new Error('Erro ao atualizar desenvolvimento.');
        return response.json();
      })
      .then(data => {
        alert('Desenvolvimento atualizado com sucesso!');
        setShowEditModal(false); // Fecha o modal
        // Atualiza a lista de desenvolvimentos após a mudança
        buscarDesenvolvimentos(); // <<--- Aqui você atualiza a lista!
        setDesenvolvimentos((prev) =>
          prev.map((item) =>
            item.ALT_ID === selectedDesenvolvimento.ALT_ID
              ? { ALT_EXECUTAR: payload.executar, ALT_STATUS: statusAtualizado, ALT_VERSAO: payload.versao, ...item }
              : item
          )
        );
      })
      .catch(error => {
        console.error('Erro ao atualizar desenvolvimento:', error);
        alert('Houve um erro ao atualizar o desenvolvimento.');
      });
  };  

  const filteredDesenvolvimentos = desenvolvimentos.filter((desenvolvimento) => {
    return (
      (!filtros.cliente || desenvolvimento.CLI_ID === Number(filtros.cliente)) &&
      (!filtros.status || desenvolvimento.ALT_STATUS === filtros.status)
    );    
  }); 
  
  // Preparar as opções para o react-select
  const options = clientes.map(cliente => ({
    value: cliente.ID,
    label: `${cliente.NOME} - ${cliente.COL_FANTASIA}`,
  }));

  return (
    <>
      <header className="header">
        <h2>Bem-vindo, {userInfo?.username || 'Usuário'}!</h2>
      </header>
      <div className="cab">
      <Link to="/menu" className="link-style">Voltar ao menu</Link>
       {/* Botão para abrir o modal de lançamento */}
      <button onClick={() => setShowLaunchModal(true)} className="btn-mais">+</button>
    </div>
      {/* Modal de Lançamento */}
      {showLaunchModal && (
        <div className="modal">
          <div className="modal-content">
            <span className="close-btn" onClick={() => setShowLaunchModal(false)}>&times;</span>
            <h2>Lançar Desenvolvimento</h2>
            <form onSubmit={handleSubmit}>
              {/* Cliente */}
              <label>Cliente:</label>
              <label>Selecione o Cliente:</label>
              <Select
                options={options}
                placeholder="Pesquise ou selecione um cliente"
                isClearable
                onChange={(selectedOption) => {
                  const selectedClienteId = selectedOption ? selectedOption.value : '';
                  
                  // Atualiza o formData
                  setFormData((prevData) => ({
                    ...prevData,
                    cliente: selectedClienteId,
                  }));

                  // Atualiza também o filtro para que a lista principal seja atualizada
                  setFiltros((prevFiltros) => ({
                    ...prevFiltros,
                    cliente: selectedClienteId,
                  }));
                }}
              />

              {/* Prioridade */}
              <label>Prioridade:</label>
              <select
                name="prioridade"
                value={formData.prioridade}
                onChange={handleInputChange}
                required
              >
                <option value="">Selecione a prioridade</option>
                <option value="Baixa">Baixa</option>
                <option value="Media">Média</option>
                <option value="Alta">Alta</option>
              </select>

              {/* Descrição */}
              <label>Descrição:</label>
              <textarea
                name="descricao"
                value={formData.descricao}
                onChange={handleInputChange}
                placeholder="Descreva o desenvolvimento..."
                rows="6"
                required
              ></textarea>

              <button type="submit" className="submit-btn">Lançar</button>
            </form>
          </div>
        </div>
      )}

      {/* Filtros */}
      <div className="filters-container">
        <label>Filtrar por Cliente:</label>
        <Select
          options={options}
          placeholder="Pesquise ou selecione um cliente"
          className="cliente-filter"
          isClearable
          onChange={(selectedOption) => {
            const selectedClienteId = selectedOption ? String(selectedOption.value) : '';

            setFormData((prevData) => ({
              ...prevData,
              cliente: selectedClienteId,
            }));

            setFiltros((prevFiltros) => ({
              ...prevFiltros,
              cliente: selectedClienteId,
            }));
          }}
        />

        <label>Filtrar por Status:</label>
        <select name="status" value={filtros.status} onChange={handleFilterChange}>
          <option value="">Todos os status</option>
          <option value="Pendente">Pendente</option>
          <option value="Em progresso">Em progresso</option>
          <option value="Disponivel">Disponivel</option>
          <option value="Implantado">Implantado</option>
        </select>
      </div>

     {/* Lista de Desenvolvimentos */}
      <ul className="desenvolvimentos-list">
        {filteredDesenvolvimentos.map(desenvolvimento => (
          <li key={desenvolvimento.ALT_ID} onClick={() => handleDesenvolvimentoClick(desenvolvimento)}>
            <div className="desenvolvimento-item">
              <h3>{desenvolvimento.NOME}</h3> {/* Nome da empresa/cliente */}
              <p><strong>Status:</strong> {desenvolvimento.ALT_STATUS}</p> {/* Status */}
              <p><strong>Data de Registro:</strong> {new Date(desenvolvimento.ALT_DTA_REGISTRO).toLocaleDateString('pt-BR')}</p> {/* Data formatada */}
              <p><strong>Prioridade:</strong> {desenvolvimento.ALT_PRIORIDADE}</p> {/* Prioridade */}
              <p><strong>Descrição:</strong> {desenvolvimento.ALT_EXECUTAR}</p> {/* Descrição */}
              <p><strong>Versão:</strong> {desenvolvimento.ALT_VERSAO}</p> {/* Versão */}
            </div>
          </li>
        ))}
      </ul>

     {/* Modal de Edição */}
      {showEditModal && selectedDesenvolvimento && (
        <div className="modal">
          <div className="modal-content">
            <span className="close-btn" onClick={() => setShowEditModal(false)}>&times;</span>
            <h2>Detalhes do Desenvolvimento</h2>
            <p><strong>Cliente:</strong> {selectedDesenvolvimento.NOME}</p>
            <p><strong>Status Atual:</strong> {selectedDesenvolvimento.ALT_STATUS}</p>
            <p><strong>Data de Registro:</strong> {new Date(selectedDesenvolvimento.ALT_DTA_REGISTRO).toLocaleDateString('pt-BR')}</p>
            <p><strong>Prioridade:</strong> {selectedDesenvolvimento.ALT_PRIORIDADE}</p>
            <form onSubmit={handleStatusUpdate}>
              {/* Atualizar Status */}
              <label>Atualizar Status:</label>
              <select
                value={statusAtualizado}
                onChange={(e) => setStatusAtualizado(e.target.value)}
                required
              >
                <option value="Pendente"></option>
                <option value="Pendente">Pendente</option>
                <option value="Em progresso">Em progresso</option>
                <option value="Disponivel">Disponivel</option>
                <option value="Implantado">Implantado</option>
              </select>

              {/* O que executar */}
              <label>O que executar:</label>
              <textarea
                value={selectedDesenvolvimento.ALT_EXECUTAR}
                onChange={(e) =>
                  setSelectedDesenvolvimento({
                    ...selectedDesenvolvimento,
                    ALT_EXECUTAR: e.target.value,
                  })
                }
                placeholder="Descreva o que deve ser executado..."
                rows="4"
                required
              ></textarea>

              {/* Versão */}
              <label>Versão:</label>
              <input
                type="text"
                value={selectedDesenvolvimento.ALT_VERSAO}
                onChange={(e) =>
                  setSelectedDesenvolvimento({
                    ...selectedDesenvolvimento,
                    ALT_VERSAO: e.target.value,
                  })
                }
                placeholder="Digite a versão (ex: 2.0.3.016)"
                required
              />

              {/* Botão de Envio */}
              <button type="submit" className="submit-btn">Salvar</button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Desenvolvimento;